import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'

export const Header = () => {
  const [state, setstate] = useState({
    slide: 0,
    ossUrl: '',
  })

  useEffect(() => {
    setstate({
      ...state,
      ossUrl: window['OSS_URL'],
    })
  }, [])

  const { ossUrl } = state

  return (
    <header>
      <Link to="/" className="navbar-brand">
        <img src="/img/coleslogo.png" alt="ANEX" className="text-logo" />
      </Link>
      <nav className="nav" role="navigation">
        <Link to="/contact" className="nav-link">
          Contact us
        </Link>
        <a className="btn btn-primary" href={ossUrl}>
          Login
        </a>
      </nav>
    </header>
  )
}
